import { Component } from "react";
import { pageLock, Navbar } from "@parksandresorts/core";
class SiteBlocks extends Component {
  constructor(props) {
    super(props);
    this.blockComponents = [];
    this.requireComponents(this.props.blocks);
  }

  requireComponents(blocks) {
    blocks.forEach((block) => {
      const blockName = block.__typename.substr(10);
      const blockPathName = blockName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

      if (!this.blockComponents[blockName]) {
        try {
          this.blockComponents[blockName] = require(`components/blocks/${blockPathName}/${blockPathName}`).default;
        } catch (e) {
          console.log(`========================================================`);
          console.log(`======> PLEASE ADD MISSING COMPONENT: ${blockName}`);
          console.log(`========================================================`);
        }
      }
    });
  }

  render() {
    const { blocks, hasHero, navbar, isShowingTopBanner } = this.props;

    // Separate the hero block and other blocks to make sure Navbar is rendered in the right place on bigger screens
    const heroBlock = hasHero && blocks.find((block) => block.__typename === "ContentfulHeroBlock");
    const otherBlocks = blocks.filter((block) => block !== heroBlock);

    const HeroBlockComponent =
      heroBlock && heroBlock.__typename && this.blockComponents[heroBlock.__typename.substr(10)];

    return (
      <div className={`blocks ${hasHero === false ? "no-hero" : ""}`}>
        {HeroBlockComponent && (
          <HeroBlockComponent key={heroBlock.id} isShowingTopBanner={isShowingTopBanner} {...heroBlock} />
        )}
        {navbar && <Navbar navbar={navbar} />}
        {otherBlocks.map((node, i) => {
          const Block = this.blockComponents[node.__typename.substr(10)];
          if (!Block) return null;
          return <Block key={node.id + i} {...node} />;
        })}
      </div>
    );
  }
}

export default pageLock(SiteBlocks);
